import './style.scss';

export function refer_form_block() {
  const block = document.querySelector('.refer_form_block');
  if (!block) return;
  
}
